import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import login from '../views/Login/index.vue'
import layout from '../layout/index.vue'
import transform from '../views/FontTransform/transform.vue'
import record from '../views/FontTransform/record.vue'
import update from '../views/User/update.vue'



Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'login',
  component: login
},
{
  path: '/layout',
  name: 'layout',
  component: layout,
  children: [
    {
      path: 'update',
      name: 'update',
      component: update

    },
    {
      path: 'transform',
      name: 'transform',
      component: transform
    },
    {
      path: 'record',
      name: 'record',
      component: record
    },
  ]
},

]

const router = new VueRouter({
  routes
})

export default router